var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"related-resources w-full"},[_c('div',{staticClass:"related-resources-wrapper"},[_c('Card',{attrs:{"display-type":_vm.displayType,"resources":_vm.resources,"title":_vm.title,"hideArrowButtons":_vm.hideArrowButtons,"loadMore":_vm.loadMoreProps},on:{"fetchMore":function($event){return _vm.$emit('loadMore')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }